import { GenIcon } from '../helpers/IconBase.es.js';

const ProductOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 5H4C3.72386 5 3.5 5.22386 3.5 5.5V7.5C3.5 7.77614 3.72386 8 4 8H5H19H20C20.2761 8 20.5 7.77614 20.5 7.5V5.5C20.5 5.22386 20.2761 5 20 5ZM2 7.5C2 8.60457 2.89543 9.5 4 9.5L4 18C4 19.6569 5.34315 21 7 21H17C18.6569 21 20 19.6569 20 18V9.5C21.1046 9.5 22 8.60457 22 7.5V5.5C22 4.39543 21.1046 3.5 20 3.5H4C2.89543 3.5 2 4.39543 2 5.5V7.5ZM5.5 18V9.5H18.5V18C18.5 18.8284 17.8284 19.5 17 19.5H7C6.17157 19.5 5.5 18.8284 5.5 18ZM9.5 14.5V12.5H14.5V14.5H9.5ZM8 12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12V15C16 15.5523 15.5523 16 15 16H9C8.44772 16 8 15.5523 8 15V12Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { ProductOutlined };
